import { StyledCol } from '@/shared/styles';
import styled from 'styled-components';

export const StyledPolicySection = styled(StyledCol)`
  gap: 12px;
  h4 {
    font-size: 16px !important;
  }
`;
